<template>
  <div
    class="border-2 rounded border-gray-400 p-2 flex"
    :class="[isFocused && 'border-gray-500']"
  >
    <textarea
      v-autosize
      :value="text"
      ref="inputRef"
      placeholder="Reply..."
      class="outline-none flex-grow resize-none"
      rows="1"
      :disabled="disabled"
      @input="onInput($event.target.value)"
      @keyup.enter.ctrl="send()"
      @focus="onFocus"
      @blur="onBlur"
    ></textarea>
    <div class="w-12 flex items-end justify-center">
      <div class="w-6 h-6 text-yellow-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="ionicon fill-current cursor-pointer hover:text-yellow-400"
          :class="[disabled && 'cursor-not-allowed']"
          viewBox="0 0 512 512"
          @click="send()"
        >
          <title>Send</title>
          <path d="M16 464l480-208L16 48v160l320 48-320 48z" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api'
import useState from 'states/generics/useState'
import autosize from '@/directives/autosize'
import useSendMessage from './useSendMessage'

export default {
  name: 'NewMessageForm',
  directives: { autosize },
  props: {
    threadId: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit, root }) {
    const { threadId } = props
    const { text, setText, sendMessage, postInProgress } = useSendMessage({
      threadId,
    })
    const inputRef = ref(null)

    const [message, setMessage] = useState(null)

    const startSendingMessage = () => {
      setMessage({
        id: null,
        text: text.value,
        ts: new Date().toISOString(),
        author: { id: null, display_name: null },
        isNew: true,
      })
      emit('on-message-send-start', message.value)
      setText('')
    }

    const focusInput = () => {
      root.$nextTick(() => {
        inputRef.value.focus()
      })
    }

    const finishSendingMessage = (messageData) => {
      setMessage(messageData)
      emit('on-message-send-finish', message.value)
      focusInput()
    }

    onMounted(() => {
      focusInput()
    })

    const send = async () => {
      if (text.value.trim().length === 0) {
        console.debug('text is empty, do not try to send this message')
        return
      }
      const request = sendMessage({ threadId: props.threadId })
      startSendingMessage()
      const response = await request
      finishSendingMessage(response.data)
    }

    const disabled = computed(() => {
      return postInProgress.value
    })

    const [isFocused, setIsFocused] = useState(false)
    const onFocus = () => {
      setIsFocused(true)
    }
    const onBlur = () => {
      setIsFocused(false)
    }

    const onInput = (val) => {
      const hasChanged = val !== text.value
      setText(val)
      emit('input', val)
      if (hasChanged) {
        emit('change', val)
      }
    }

    return {
      text,
      onInput,
      send,
      disabled,
      inputRef,

      isFocused,
      onFocus,
      onBlur,
    }
  },
  methods: {
    focus() {
      this.$refs.inputRef.focus()
    },
  },
}
</script>
